import superManager from "./superManager";
import comO1Box from "../components/comO1Box";
import data_control from "../libs/data_control";

export enum O1BoxGroup {
    NORMAL,
    GAME,
}

export enum CollisionDirection {
    NULL,
    UP,
    DOWN,
    LEFT,
    RIGHT
}

interface CollisionGroup {
    [id: string]: boolean;
}

interface O1BoxMap {
    [id: string]: comO1Box;
}

interface ReactionMap {
    [idId: string]: boolean;
}

interface CollisionBoxMap {
    [idId: string]: boolean;
}

export default class o1BoxManager extends superManager {
    //
    protected readonly className: string = '简单碰撞管理';
    //反应时间
    static readonly UPDATE_TICK: number = 5;
    //重力加速度
    protected readonly GRAVITY: number = 10 / 1000 * 2.5;

    constructor() {
        super();
    }

    //碰撞分组
    protected m_collisionGroupMap: CollisionGroup = {};
    //碰撞组件队列
    protected m_o1Boxes: O1BoxMap = {};
    //
    protected m_fpsReactionMap: ReactionMap = {};
    //已碰撞字典
    protected m_collisionBoomMap: CollisionBoxMap = {};

    async loadManager(): Promise<boolean> {
        await super.loadManager();
        this.init();
        //
        return Promise.resolve(true);
    }

    init() {
        this.m_collisionGroupMap = {};
        this.m_o1Boxes = {};
        this.m_collisionBoomMap = {};
        this.addBoxCollisionGroup(O1BoxGroup.GAME, O1BoxGroup.GAME);
        // setInterval(this.onUpdate.bind(this), this.UPDATE_TICK);
    }

    overFrame() {

    }

    clearBoxCollisionGroup() {
        this.m_collisionGroupMap = {};
        this.m_o1Boxes = {};
        this.m_collisionBoomMap = {};
    }

    onCollisionAABB(aPos: cc.Vec2, aSize: cc.Size, bPos: cc.Vec2, bSize: cc.Size): CollisionDirection {
        let xDistance = Math.abs(aPos.x - bPos.x);
        let yDistance = Math.abs(aPos.y - bPos.y);
        let hrefX = (aSize.width + bSize.width) / 2;
        let hrefY = (aSize.height + bSize.height) / 2;
        //碰到
        if (xDistance <= hrefX && yDistance <= hrefY) {
            //谁离得更远
            if (xDistance / hrefX >= yDistance / hrefY) {
                return aPos.x < bPos.x ? CollisionDirection.LEFT : CollisionDirection.RIGHT;
            } else {
                return aPos.y > bPos.y ? CollisionDirection.UP : CollisionDirection.DOWN;
            }
        }
        return CollisionDirection.NULL;
    }

    onUpdateOneLineVelocity(box: comO1Box) {
        box.getProductLastLineVelocity().y -= this.GRAVITY * box.gravity;
    }

    onUpdateOnePos(box: comO1Box) {
        // const srcPos = box.node.getPosition().clone();
        // let movePos = srcPos.add(box.lineVelocity);
        const srcPos = box.getPredictLastPos();
        const movePos = srcPos.add(box.getProductLastLineVelocity());
        //判断碰撞
        for (let id in this.m_o1Boxes) {
            const oBox = this.m_o1Boxes[id];
            let srcGroup = box.boxGroup;
            let bomGroup = oBox.boxGroup;
            //自己不碰撞
            if (box.id == id) {
                continue;
            }
            //不能碰撞
            if (!this.isCanCollision(srcGroup, bomGroup)) {
                continue;
            }
            //碰撞
            // let boomRes = this.onCollisionAABB(movePos, box.node.getContentSize(), oBox.node.getPosition(), oBox.node.getContentSize());
            let boomRes = this.onCollisionAABB(movePos, box.node.getContentSize(), oBox.getPredictLastPos(), oBox.node.getContentSize());
            //已经计算过碰撞
            let aId = `${box.id}+${oBox.id}`;
            let bId = `${box.id}+${oBox.id}`;
            //已经碰撞回调过
            let boomed = false;
            //有碰撞
            let boomCb = false;
            if (this.m_collisionBoomMap[aId] || this.m_collisionBoomMap[bId]) {
                boomed = true;
            }
            if (boomRes != CollisionDirection.NULL) {
                this.m_collisionBoomMap[aId] = this.m_collisionBoomMap[bId] = true;
                boomCb = true;
            }
            const lineVelocity = box.getProductLastLineVelocity();
            const boxPos = box.getPredictLastPos();
            switch (boomRes) {
                case CollisionDirection.UP: {
                    lineVelocity.y = 0;
                    //
                    let pos = oBox.getPredictLastPos().y + oBox.node.height / 2 + box.node.height / 2;
                    boxPos.y = pos;
                    break;
                }
                case CollisionDirection.DOWN: {
                    lineVelocity.y = 0;
                    //
                    let pos = oBox.getPredictLastPos().y - oBox.node.height / 2 - box.node.height / 2;
                    boxPos.y = pos;
                    break;
                }
                case CollisionDirection.LEFT: {
                    lineVelocity.x = 0;
                    //
                    let pos = oBox.getPredictLastPos().x - oBox.node.width / 2 - box.node.width / 2;
                    boxPos.x = pos;
                    break;
                }
                case CollisionDirection.RIGHT: {
                    lineVelocity.x = 0;
                    //
                    let pos = oBox.getPredictLastPos().x + oBox.node.width / 2 + box.node.width / 2;
                    boxPos.x = pos;
                    break;
                }
                default: {
                    boxPos.x += lineVelocity.x;
                    boxPos.y += lineVelocity.y;
                    if (this.m_collisionBoomMap[aId] || this.m_collisionBoomMap[bId]) {
                        delete this.m_collisionBoomMap[aId];
                        delete this.m_collisionBoomMap[bId];
                        this.onEmitCollisionCallback(box, oBox, 'onCollisionBoxLearn');
                    }
                    break;
                }
            }
            //通知回调
            if (!boomed && boomCb) {
                this.onEmitCollisionCallback(box, oBox, 'onCollisionBox');
            }
        }
    }

    onEmitCollisionCallback(box: comO1Box, otherBox: comO1Box, cbFunctionName: string) {
        const comList = box.getComponents(cc.Component);
        comList.forEach(com => {
            if (com[cbFunctionName] != null) {
                com[cbFunctionName](otherBox);
            }
        });

    }

    //物理更新
    onUpdate() {
        //
        this.m_fpsReactionMap = {};
        //数据
        for (let id in this.m_o1Boxes) {
            const com = this.m_o1Boxes[id];
            if (com.isDynamic) {
                com.pushLastPredictLineVelocity();
                com.onUpdateLogicStart();
                this.onUpdateOneLineVelocity(com);
            }
        }
        for (let id in this.m_o1Boxes) {
            const com = this.m_o1Boxes[id];
            if (com.isDynamic) {
                com.pushLastPredictPos();
                com.onUpdateLogicEnd();
                this.onUpdateOnePos(com);
            }
        }
    }

    onTimerPredictSync() {
        for (let k in this.m_o1Boxes) {
            const box = this.m_o1Boxes[k];
            if (!box.isDynamic) continue;
            //
            box.onTimerRunSync();
        }
    }

    isHaveLastPos(): boolean {
        for (let k in this.m_o1Boxes) {
            if (this.m_o1Boxes[k].isHaveLastPos() || this.m_o1Boxes[k].isHaveLastPos()) {
                return true;
            }
        }
        return false;
    }


    addBox(box: comO1Box) {
        if (box.id) {
            console.error('#591651已经添加BOX');
            return;
        }
        do {
            const id = data_control.getRandId();
            if (!this.m_o1Boxes[id]) {
                box.id = id;
                this.m_o1Boxes[id] = box;
                break;
            }
            console.warn('#701654 几乎不可能的重复', id, this.m_o1Boxes);
        } while (true);
    }

    deleteBox(box: comO1Box) {
        const {id} = box;
        if (id) {
            delete this.m_o1Boxes[id];
        } else {
            console.error('#481620 空的ID');
        }
    }

    addBoxCollisionGroup(group1: O1BoxGroup, group2: O1BoxGroup) {
        let id = `${group1}-${group2}`;
        let id2 = `${group2}-${group1}`;
        this.m_collisionGroupMap[id] = true;
        this.m_collisionGroupMap[id2] = true;
    }

    isCanCollision(group1: O1BoxGroup, group2: O1BoxGroup): boolean {
        let id = `${group1}-${group2}`;
        return this.m_collisionGroupMap[id];
    }
}

























